import script from "./TransparencySwipable.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransparencySwipable.vue?vue&type=script&setup=true&lang=ts"

import "./TransparencySwipable.vue?vue&type=style&index=0&id=1c6d0d0b&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c6d0d0b"]])

export default __exports__